module.exports = __webpack_public_path__ + "static/media/csv-file.ea1afc99.svg";